var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "32px",
    viewBox: "0 0 16 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F22EB9FD-6670-46C1-882E-41BFD5DBF037") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-4",
    transform: "translate(-749.000000, -733.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(749.000000, 733.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.5887327,0 0,2.96248598 0,6.6039713 L0,15.8475442 C0,19.4890295 3.5887327,22.4515155 8,22.4515155 C12.4112673,22.4515155 16,19.4890295 16,15.8475442 L16,6.6039713 C16,2.96248598 12.4112673,0 8,0 Z M14.3682108,15.7209733 C14.3682108,18.5401878 11.5113348,20.8339441 7.99999997,20.8339441 C4.48866525,20.8339441 1.63178918,18.5401878 1.63178918,15.7209733 L1.63178918,6.73054133 C1.63178918,3.91132688 4.48866525,1.61757054 7.99999997,1.61757054 C11.5113348,1.61757054 14.3682108,3.91132688 14.3682108,6.73054133 L14.3682108,15.7209733 Z",
    id: "Shape",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00020751,5.36324187 C7.54951498,5.36324187 7.18431293,5.72526173 7.18431293,6.1720272 L7.18431293,9.8946609 C7.18431293,10.3412206 7.54951498,10.7034462 8.00020751,10.7034462 C8.45069256,10.7034462 8.8161021,10.3412206 8.8161021,9.8946609 L8.8161021,6.1720272 C8.8161021,5.72526173 8.45090005,5.36324187 8.00020751,5.36324187 Z",
    id: "Path",
    fill: "#FF5043"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0942261,29.2104355 L6.82915388,32.4982327 C6.70181646,32.6264576 6.53465549,32.6909091 6.36746391,32.6909091 C6.20030294,32.6909091 6.03311136,32.6264576 5.90577395,32.4982327 C5.6504563,32.2411356 5.6504563,31.8255452 5.90577395,31.5684481 L8.70918677,28.7455278 L5.90580456,25.9226074 C5.65048691,25.6655103 5.65048691,25.2499199 5.90580456,24.9928228 C6.1611222,24.7357257 6.57383624,24.7357257 6.82915388,24.9928228 L10.0942261,28.2806509 C10.3495437,28.5377479 10.3495437,28.9533076 10.0942261,29.2104355 Z",
    id: "Shape-Copy",
    fill: "#A8A8A8",
    transform: "translate(8.000000, 28.745455) rotate(90.000000) translate(-8.000000, -28.745455) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.bb790d99bfc20ff398def45b4223c9b5.svg";
export { ForwardRef as ReactComponent };